export const CORE = "https://api.hedgedbitcoin.com";
export const upholdAuth = "https://uphold.com/authorize/560b322c8782a6cb19a73c0d40a3e0c86e57b778?scope=user:read%20cards:read%20cards:write%20transactions:transfer:application";


// WEBPACK FOOTER //
// ./src/config/http.js